/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import * as types from './types';

export const state = {
  list: [],
  actived: false,
  load: false,
  activeNew: false,
  providers: [],
  products: [],
  showAmount: false,
  showSubmit: false,
  showNumber: false,
  showLoad: false,
  recharge: {},
  showError: false,
  showSuccess: false,
  showConfirm: false,
  showCancel: false,
  errors: {},
};

export const mutations = {
  [types.LIST](state, list) {
    state.list = list;
  },
  [types.ACTIVED](state, actived) {
    state.actived = actived;
  },
  [types.IS_LOAD](state, isLoad) {
    state.isLoad = isLoad;
  },
  [types.ACTIVE_NEW](state, activeNew) {
    state.activeNew = activeNew;
  },
  [types.PROVIDERS](state, providers) {
    state.providers = providers;
  },
  [types.PRODUCTS](state, products) {
    state.products = products;
  },
  [types.SHOW_AMOUNT](state, showAmount) {
    state.showAmount = showAmount;
  },
  [types.SHOW_NUMBER](state, showNumber) {
    state.showNumber = showNumber;
  },
  [types.SHOW_SUBMIT](state, showSubmit) {
    state.showSubmit = showSubmit;
  },
  [types.SHOW_LOAD](state, showLoad) {
    state.showLoad = showLoad;
  },
  [types.RECHARGE](state, recharge) {
    state.recharge = recharge;
  },
  [types.SHOW_ERROR](state, showError) {
    state.showError = showError;
  },
  [types.ERRORS](state, errors) {
    state.errors = errors;
  },
  [types.SHOW_SUCCESS](state, showSuccess) {
    state.showSuccess = showSuccess;
  },
  [types.SHOW_CONFIRM](state, showConfirm) {
    state.showConfirm = showConfirm;
  },
  [types.SHOW_CANCEL](state, showCancel) {
    state.showCancel = showCancel;
  },
};
